/* eslint-disable */
import * as THREE from 'three';
import aesjs from 'aes-js';
import pako from 'pako';
/**
 * @author Jones Chi / http://tg3ds.com
 *
 * Description: A THREE loader for TGS files.
 *
 */


THREE.TGSLoader = function ( manager ) {

	this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

	this.propertyNameMapping = {};

};

THREE.TGSLoader.prototype = {

	constructor: THREE.TGSLoader,

	load: function ( url, onLoad, onProgress, onError ) {
		let scope = this;
		// var loader = new THREE.XHRLoader( this.manager );
		// loader.setCrossOrigin( this.crossOrigin );
		var loader = new THREE.FileLoader( scope.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.load( url, function ( data ) {
			onLoad( scope.parse( data ) );
		}, onProgress, onError );
	},

	setCrossOrigin: function ( value ) {
		this.crossOrigin = value;
	},

	parse: function ( data ) {
		var vertices = [];
		var object = new THREE.Object3D();
		var geometry = new THREE.Geometry();
		var material = new THREE.MeshLambertMaterial();
		var mesh = new THREE.Mesh( geometry, material );
		object.add(mesh);

		var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9+/=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/rn/g,"n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=0;var c1=0;var c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{var c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

		function binaryRead( dataview, at, type, little_endian ) {
			switch ( type ) {

			// corespondences for non-specific length types here match rply:
			case 'int8': case 'char': return [ dataview.getInt8( at ), 1 ];

			case 'uint8': case 'uchar': return [ dataview.getUint8( at ), 1 ];

			case 'int16': case 'short': return [ dataview.getInt16( at, little_endian ), 2 ];

			case 'uint16': case 'ushort': return [ dataview.getUint16( at, little_endian ), 2 ];

			case 'int32': case 'int':  return [ dataview.getInt32( at, little_endian ), 4 ];

			case 'uint32': case 'uint': return [ dataview.getUint32( at, little_endian ), 4 ];

			case 'float32': case 'float': return [ dataview.getFloat32( at, little_endian ), 4 ];

			case 'float64': case 'double': return [ dataview.getFloat64( at, little_endian ), 8 ];

			}
		}

		function vector(x, y, z) {
			return new THREE.Vector3(x, y, z);
		}

		function face3(a, b, c, normals) {
			return new THREE.Face3(a, b, c, normals);
		}

		function addVertex(a, b, c) {
			vertices.push(geometry.vertices.push(vector(a, b, c)));
		}

		function addFace(a, b, c) {
			geometry.faces.push(face3(a - 1, b - 1, c - 1));
		}

		var m = 'MTA';
		var magich = new Uint8Array(data, 0, 4);
		if (magich[0] != 't'.charCodeAt(0) || magich[1] != 'g'.charCodeAt(0) ||
			magich[2] != 's'.charCodeAt(0) || magich[3] != '0'.charCodeAt(0)) {
			return null;
		}
		data = new DataView(data, 4);
		var cur_index = 0;
		var ver = binaryRead(data, cur_index, 'uint16', true)[0];
		cur_index += 2;
		var hlen = binaryRead(data, cur_index, 'uint32', true)[0];
		cur_index += 4;
		var dlen = binaryRead(data, cur_index, 'uint32', true)[0];
		cur_index += 4;

		if (ver != 1 || hlen != 34 || dlen <= 0) {
			return null;
		}

		// reserve
		cur_index += 20;

		var key1 = [50, 51, 52, 53];
		var d = parseInt(Base64.decode(m + '='));
		var k = Math.pow(d, 2)
		var d = Base64.decode('YmRn');
		for (var i = 0; i < 3; i++) {
			key1.push(d[i].charCodeAt(0) - 1);
		}
		d = Base64.decode('MWE0Zjg3M' + Base64.decode('alEz'));
		for (var i = 0; i < 9; i++) {
			key1.push(d[i].charCodeAt(0));
		}
		var iv1 = [];
		for (var i = 0; i < 16; i++) {
			iv1.push(binaryRead(data, cur_index + i, 'uchar', true)[0]);
		}
		cur_index += 16;

		key1[0] = 54;
		key1.push(102);
		var key2 = [51, 52, 53, 54, 55, 56];
		var iv2 = [];
		for (var i = 0; i < 16; i++) {
			iv2.push(binaryRead(data, cur_index + i, 'uchar', true)[0]);
		}
		key1.push(++k);
		key1.splice(2, 2);
		d = Base64.decode('NGI4Njc5');
		k = Base64.decode('YXZndGVz');
		for (var i = 0; i < 6; i++) {
			key2.push(d[i].charCodeAt(0));
		}
		key2.push(35 ^ (k.length * 11));
		key2.push(35 ^ (k.length * 11));

		var XOR_KEY = (key1.length + key2.length) * 6 + iv1.length;
		cur_index += 16;

		key2[2] += 3;
		var aesCbc1 = new aesjs.ModeOfOperation.cbc(key1, iv1);
		k = Math.pow(key2[0]/3, 3);
		key2.splice(4, 1);
		k = String(k - 744);
		d = k.substr(2);
		key2.push(k.charCodeAt(0));
		key2.push(k.charCodeAt(1));
		key2.splice(0, 1);
		key2.push(d.charCodeAt(0));
		key2.push(d.charCodeAt(1));
		key2[10]++;
		key2[11]++;
		var aesCbc2 = new aesjs.ModeOfOperation.cbc(key2, iv2);

		var AES_BLOCK_SIZE = 128;

		var p = 0;
		var deflated = [];
		XOR_KEY += iv2.length + 6;
		while (cur_index < data.byteLength) {
			var aes_block = [];
			var aes_block_hex = '';
			var aes_b1 = 0;
			var aes_b2 = 0;
			for (var i = 0; i < AES_BLOCK_SIZE; i++) {
				aes_block.push(binaryRead(data, cur_index, 'uchar', true)[0]);
				cur_index++;
				if (cur_index >= data.byteLength) {
					break;
				}
			}
			var a = aes_block[0] ^ XOR_KEY;
			var b = aes_block[0] ^ aes_block[1];
			aes_block[0] = a;
			aes_block[1] = b;
			for (var b = 0; b < 8; b++) {
				var decryptedBytes;
				var decrypt_block = [];
				for (var i = 0; i < 16; i++) {
					decrypt_block.push(aes_block[b*16 + i]);
				}
				if (p % 2 == 0) {
					decryptedBytes = aesCbc1.decrypt(decrypt_block);
				} else {
					decryptedBytes = aesCbc2.decrypt(decrypt_block);
				}
				deflated.push.apply(deflated, decryptedBytes);
			}
			p++;
		}

		// decompress
		var binData = new Uint8Array(deflated);
		binData = new Uint8Array(binData.buffer, 0, dlen - 32);
		var rawTgs = pako.inflate(binData);

		// extract tgs
		data = new DataView(rawTgs.buffer);
                cur_index = 0;
		while (cur_index < rawTgs.length) {
			if (binaryRead(data, cur_index + 0, 'uchar', true)[0] != 0 ||
			    binaryRead(data, cur_index + 1, 'uchar', true)[0] != 0 ||
			    binaryRead(data, cur_index + 2, 'uchar', true)[0] != 61 ||
			    binaryRead(data, cur_index + 3, 'uchar', true)[0] != 2) {
				break;
			}
			cur_index += 4;
			var type = binaryRead(data, cur_index, 'uchar', true)[0];
			cur_index += 1;
			var count = binaryRead(data, cur_index, 'uint32', true)[0];
			cur_index += 4;
			if (type == 118) {
				// vertex
				var base_x = binaryRead(data, cur_index, 'float32', true)[0];
				cur_index += 4;
				var base_y = binaryRead(data, cur_index, 'float32', true)[0];
				cur_index += 4;
				var base_z = binaryRead(data, cur_index, 'float32', true)[0];
				cur_index += 4;
				addVertex(base_x, base_y, base_z);
				for (var i = 0; i < count; i++) {
					var x = binaryRead(data, cur_index, 'int16', true)[0];
					x /= 100.0;
					x += base_x;
					cur_index += 2;
					var y = binaryRead(data, cur_index, 'int16', true)[0];
					y /= 100.0;
					y += base_y;
					cur_index += 2;
					var z = binaryRead(data, cur_index, 'int16', true)[0];
					z /= 100.0;
					z += base_z;
					cur_index += 2;
					addVertex(x, y, z);
				}
			} else if (type == 102) {
				// face
				var base_x = binaryRead(data, cur_index, 'uint32', true)[0];
				cur_index += 4;
				var base_y = binaryRead(data, cur_index, 'uint32', true)[0];
				cur_index += 4;
				var base_z = binaryRead(data, cur_index, 'uint32', true)[0];
				cur_index += 4;
				addFace(base_x, base_y, base_z);
				for (var i = 0; i < count; i++) {
					var x = binaryRead(data, cur_index, 'int16', true)[0];
					x += base_x;
					cur_index += 2;
					var y = binaryRead(data, cur_index, 'int16', true)[0];
					y += base_y;
					cur_index += 2;
					var z = binaryRead(data, cur_index, 'int16', true)[0];
					z += base_z;
					cur_index += 2;
					addFace(x, y, z);
				}
			}
		}

		var children = object.children;
		for (var i = 0, l = children.length; i < l; i++) {
			var geometry = children[i].geometry;
			geometry.computeFaceNormals();
			geometry.computeBoundingSphere();
		}
		return object;
	}
};
